import { Logo } from "../Logo";
import { AdminNavLinks } from "./AdminNavLinks";

export const AdminSidebar = () => (
  <aside className="hidden md:flex flex-col w-60 shrink-0 bg-midnight-black h-screen sticky top-0" data-testid="admin-sidebar">
    <div className="px-5 py-6 border-b border-white/10">
      <div className="bg-white/5 rounded-lg px-3 py-2 inline-block">
        <Logo className="h-7" />
      </div>
    </div>
    <AdminNavLinks />
  </aside>
);
